export const copyTextFromElement = (selector, container) => {
  const field = document.querySelector(selector);
  return copyText(field.textContent.toString(), container);
};

export const copyText = (text, container = document.body) => {
  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    container.appendChild(textArea);
    textArea.select();
    textArea.focus();
    document.execCommand('copy');
    textArea.remove();
    window.getSelection().removeAllRanges();
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Copy to clipboard with new Clipboard API if available.
 * @param {string} text Data to be written
 * @returns true if action was successful.
 */
export const copyToClipboard = async text => {
  try {
    await window.navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    return false;
  }
};
